import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import ProductCardStatic from 'components/consumer/ProductCardStatic';
const ProductGridItem = t0 => {
  const $ = _c(15);
  const {
    idx,
    layout,
    productItem
  } = t0;
  const key = productItem?.id.toString ?? `product-item-${idx}`;
  let t1;
  if ($[0] !== productItem.variantsToShow) {
    t1 = productItem.variantsToShow ?? [];
    $[0] = productItem.variantsToShow;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== productItem.variants) {
    t2 = productItem.variants ?? [];
    $[2] = productItem.variants;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = idx + 1;
  let t4;
  if ($[4] !== key || $[5] !== layout || $[6] !== productItem.id || $[7] !== productItem.isFavorited || $[8] !== productItem.name || $[9] !== productItem.productLabel || $[10] !== productItem.secondaryImage || $[11] !== t1 || $[12] !== t2 || $[13] !== t3) {
    t4 = <ProductCardStatic layout={layout} id={productItem.id} name={productItem.name} variantsToShow={t1} variants={t2} secondaryImage={productItem.secondaryImage} productLabel={productItem.productLabel} isFavorited={productItem.isFavorited} position={t3} key={key} />;
    $[4] = key;
    $[5] = layout;
    $[6] = productItem.id;
    $[7] = productItem.isFavorited;
    $[8] = productItem.name;
    $[9] = productItem.productLabel;
    $[10] = productItem.secondaryImage;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};
ProductGridItem.propTypes = {
  idx: PropTypes.number,
  layout: PropTypes.oneOf(['full', 'mini', 'minimal', 'minimal-with-attributes', 'minimal-with-showroom']),
  productItem: PropTypes.shape({
    campaign: PropTypes.string,
    enableMobileCarousel: PropTypes.bool,
    filterStateKey: PropTypes.string,
    hidden: PropTypes.bool,
    id: PropTypes.number.isRequired,
    initialOptionId: PropTypes.string,
    isClearance: PropTypes.bool,
    isFavorited: PropTypes.bool,
    layout: PropTypes.oneOf(['full', 'mini', 'minimal', 'minimal-with-attributes', 'minimal-with-showroom']),
    moreVariantsCount: PropTypes.number,
    name: PropTypes.string,
    onDisplayInShowroomSlug: PropTypes.string,
    path: PropTypes.string,
    position: PropTypes.number,
    productFamily: PropTypes.string,
    productLabel: PropTypes.string,
    productType: PropTypes.string,
    quickship: PropTypes.bool,
    secondaryImage: PropTypes.string,
    secondaryImageCropData: PropTypes.object,
    slug: PropTypes.string,
    variantsToShow: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      image: PropTypes.string,
      isOutOfStock: PropTypes.bool,
      label: PropTypes.string,
      minPrice: PropTypes.number,
      originalPrice: PropTypes.number,
      path: PropTypes.string.isRequired,
      price: PropTypes.number.isRequired,
      quickship: PropTypes.bool,
      sku: PropTypes.string
    })),
    variants: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      image: PropTypes.string,
      isOutOfStock: PropTypes.bool,
      label: PropTypes.string,
      minPrice: PropTypes.number,
      originalPrice: PropTypes.number,
      path: PropTypes.string.isRequired,
      price: PropTypes.number.isRequired,
      quickship: PropTypes.bool,
      isFavorited: PropTypes.bool,
      sku: PropTypes.string
    })),
    variantsTotal: PropTypes.number
  })
};
export default ProductGridItem;